export default class MediaDataManager{
    static updateMediaUrls = (obj) => {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];

                if (value && typeof value === 'object') {
                    if (value.lastAccessTimeUtc) {
                        // This is a mediaEntity
                        value.url = global.mediaFileBaseUrl + value.name;
                    } else {
                        // Recursively process nested objects and arrays
                        this.updateMediaUrls(value);
                    }
                }
            }
        }
    }

}